import type { CellContext } from '@tanstack/react-table'

import { formatDate, humanizeDate } from '@/utils'

export const DateCell = (cell: CellContext<any, string>) =>
  formatDate(cell.getValue())

export const HumanizedDateCell = (cell: CellContext<any, string>) =>
  humanizeDate(cell.getValue())
